import auth from '@/router/auth'
import PromotionIndex from '@/components/configmenus/Index'
import PromotionCreate from '@/components/configmenus/Create'
import PromotionUpdate from '@/components/configmenus/Update'
import PromotionShow from '@/components/configmenus/Show'

export default [
  {
    path: '/configmenus',
    name: 'configmenus-index',
    component: PromotionIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/configmenus/create',
    name: 'configmenus-create',
    component: PromotionCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/configmenus/update/:id',
    name: 'configmenus-update',
    component: PromotionUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/configmenus/show/:id',
    name: 'configmenus-show',
    component: PromotionShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/configmenus/router.js